import React from "react";
import PropTypes from "prop-types";

const Commitee = ({data}) => {
  // const [didViewCountUp, setDidViewCountUp] = useState(false);
  // const onVisibilityChange = isVisible => {
  //     if (isVisible) {
  //     setDidViewCountUp(true);
  //     }
  // };
  return (
    <tr height={18}>
      <td height={18}>
        <div align="left">{data.FirstName}</div>
      </td>
      <td>
        <div align="left">{data.LastName}</div>
      </td>
      <td>{data.Affiliate}</td>
    </tr>
  );
};

Commitee.propTypes = {
  data: PropTypes.object,
};

export default Commitee;
